export enum InviteMethod {
    Email = 'email',
    Link = 'link',
}
